var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "find-user box is-centered",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("h1", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v("\n    Buscar Usuarios\n  ")
      ]),
      _c(
        "div",
        { staticClass: "column is-12-mobile is-12-fullhd is-6" },
        [
          _c("AppInputField", {
            attrs: {
              id: "email",
              name: "email",
              label: "Email:",
              "left-icon": "email",
              placeholder: "NO es necesario el email completo.",
              value: _vm.email,
              disabled: _vm.isLoading
            },
            on: { input: _vm.onChange, change: _vm.onChange }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12-mobile is-12-fullhd is-6" },
        [
          _c("AppInputField", {
            attrs: {
              id: "accountNumber",
              name: "accountNumber",
              label: "Número de cuenta:",
              "left-icon": "accountNumber",
              placeholder: "Número de cuenta.",
              value: _vm.accountNumber,
              disabled: _vm.isLoading
            },
            on: { input: _vm.onChangeCompany, change: _vm.onChangeCompany }
          })
        ],
        1
      ),
      _c("ButtonSubmit", {
        attrs: { "is-loading": _vm.isLoading, text: "Buscar usuarios" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }